import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function MarkerInfo({
  color = 'icon.primary',
  fill = 'transparent',
  ...props
}) {
  return (
    <IconBase viewBox='-0.5 -0.5 15 15' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7 14C3.13367 14 0 10.8663 0 7C0 3.13367 3.13367 0 7 0C10.8663 0 14 3.13367 14 7C14 10.8663 10.8663 14 7 14Z'
        stroke={color}
        fill={fill}
      />
      <Path
        d={
          'M7.06843 3.71622C7.18778 3.71622 7.28465 3.81308 ' +
          ' 7.28378 3.93243C7.28378 4.05178 7.18692 4.14865 ' +
          '7.06756 4.14865C6.94821 4.14865 6.85135 4.05178 ' +
          '6.85135 3.93243C6.85135 3.81308 6.94821 3.71622 7.06843 3.71622'
        }
        stroke={color}
        strokeWidth='1.2973'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M7.0625 6.5V10.8243'
        stroke={color}
        stroke-width='1.2973'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </IconBase>
  )
}

MarkerInfo.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default MarkerInfo
